import * as type from "../types";

const initialState = {
    availableDrivers: [],
    ecoChart: []
};

export default (state = initialState, action) => {
    switch (action.type) {
        case type.SET_ALL_DRIVERS:
            return {
                ...state,
                availableDrivers: action.value
            };
        case type.DELETE_DRIVER:
            return {
                ...state,
                availableDrivers: state.availableDrivers.filter(driver => driver.kierowca_id !== action.value)
            };
        case type.ADD_DRIVER:
            return {
                ...state,
                availableDrivers: [action.value, ...state.availableDrivers]
            };
        case type.UPDATE_DRIVER:
            return {
                ...state,
                availableDrivers: state.availableDrivers.map(driver =>{
                    if(driver.kierowca_id === action.value.kierowca_id)
                        return action.value;
                    return driver;
                })
            };
        case type.SET_DRIVER_ECO_CHART:
            return {
                ...state,
                ecoChart: action.value
            };
        case type.SET_DRIVER_MOBILE_APP_KEY:
            return {
                ...state,
                availableDrivers: state.availableDrivers.map(driver => {
                    if(driver.kierowca_id === action.value.kierowca_id)
                        return action.value;
                    return driver;
                })
            };
        default:
            return state;
    }
};
